<section class="py-3">
  <div class="container-fluid card">
    <h3 class="text strat pt-3">Service Information</h3>
    <form (ngSubmit)="saveProduct()" [formGroup]="addServiceForm">
      <div class="row pt-3 g-3">
        @if (userDetails?.enrollmentType === "Company") {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="branchSelect">Branch<span class="text-danger">*</span></label>
          <select class="form-select default-form-group-border" id="branchSelect" formControlName="branch"
            (change)="onBranchChange()">
            <option value="" disabled>Select Branch</option>
            @for (company of companyData; track company) {
            <option [value]="company._id">
              {{ company.name }}
            </option>
            }
          </select>
        </div>
        }
      </div>
      <h3 class="pt-3">Service Details:</h3>
      <div class="row pt-2 g-3">
        @for (field of metaDataList; track field; let i = $index) {
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <div class="card service-card h-100 p-3 border rounded-3 cursor-pointer"
            [class.active-service]="selectedServices[field._id]" (click)="toggleService(field)">
            <div class="d-flex align-items-start justify-content-between flex-wrap gap-1 mb-2">
              <div class="form-check form-switch m-0">
                <input class="form-check-input cursor-pointer" type="checkbox" [id]="'switch_' + field._id"
                  [checked]="selectedServices[field._id]" style="pointer-events: none;">
                <label [attr.for]="'switch_' + field._id" class="form-check-label fw-bold text-dark ms-1 text-break" style="pointer-events: none;">
                  {{ field.label }}
                </label>
              </div>
              @if ((field.amount && field.amount > 0) || (field.minAmount && field.minAmount > 0)) {
              <span class="badge bg-light text-secondary border fw-normal flex-shrink-0"
                style="font-size: 10px; max-width: 100%;">
                Default: ₹{{ field.amount || field.minAmount }}
              </span>
              }
            </div>

            <div class="mt-2">
              <div class="input-group input-group-sm" (click)="$event.stopPropagation()">
                <span class="input-group-text bg-light text-muted fw-bold">₹</span>
                <input [formControlName]="field._id" [id]="field._id" type="number" min="1"
                  class="form-control no-spinner default-form-group-border" placeholder="Enter amount"
                  (input)="onAmountInput(field)" appBlockNumberSpecialchars [appMaxLength]="10" />
              </div>
              @if (selectedServices[field._id] && addServiceForm.get(field._id)?.invalid &&
              (addServiceForm.get(field._id)?.touched || addServiceForm.get(field._id)?.dirty)) {
              <small class="text-danger d-block mt-1">
                @if (addServiceForm.get(field._id)?.hasError('required')) {
                Amount is required
                } @else if (addServiceForm.get(field._id)?.hasError('min')) {
                Amount must be greater than 0
                }
              </small>
              }
            </div>
          </div>
        </div>
        }
      </div>
      <h3 class="pt-3">Payment Details:</h3>
      <div class="row pt-3 g-3">
        <div class="col-12 col-sm-6 col-md-3">
          <label for="totalAmountInput">Total Price<span class="text-danger">*</span></label>
          <input formControlName="totalAmount" id="totalAmountInput" #totalAmount type="number"
            class="form-control no-spinner default-form-group-border" placeholder="Total price" required readonly />
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="discountInput">Discount on Total Price</label>
          <input formControlName="discount" id="discountInput" #discount type="number"
            class="form-control no-spinner default-form-group-border" placeholder="Discount amount"
            (change)="calculateTotalService()" />
          @if (addServiceForm.get('discount')?.errors?.['discountExceeded']) {
          <div>
            <small class="text-danger">Discount cannot be greater than or equal to the total amount.</small>
          </div>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="paymentTypeSelect">Payment Type<span class="text-danger">*</span></label>
          <ng-select labelForId="paymentTypeSelect" [items]="paymentTypes" bindLabel="label" bindValue="value" formControlName="paymentType"
            [clearable]="false" placeholder="Select Payment Type" (change)="showPayDetailsForm($event.value)"
            class="custom-ng-select">
          </ng-select>
          @if (
          addServiceForm.get("paymentType")?.invalid &&
          addServiceForm.get("paymentType")?.touched
          ) {
          <div>
            <small class="text-danger">Select payment type</small>
          </div>
          }
        </div>
        @if (showFullPaymentOption) {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="paymentModeSelect">Payment Mode<span class="text-danger">*</span></label>
          <ng-select labelForId="paymentModeSelect" [items]="paymentModes" bindLabel="label" bindValue="value" formControlName="paymentMode"
            [clearable]="false" placeholder="Select Payment Mode" (change)="onPaymentModeChange($event.value)"
            class="custom-ng-select">
          </ng-select>
          @if (
          addServiceForm.get("paymentMode")?.invalid &&
          addServiceForm.get("paymentMode")?.touched
          ) {
          <div>
            <small class="text-danger">Select payment mode</small>
          </div>
          }
        </div>
        }
        @if (showSwpCharges && showFullPaymentOption) {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="swpChargesInput">SWP Charges</label>
          <input formControlName="swpCharges" id="swpChargesInput" #swpCharges type="number"
            class="form-control no-spinner default-form-group-border" placeholder="Swipe charge %"
            (change)="calculateTotalService()" />
        </div>
        }
        @if (
        showFullPaymentOption &&
        addServiceForm.get("paymentMode")?.value !== "Credit"
        ) {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="paymentAccountSelectFull">Payment Account</label>
          <div class="d-flex align-items-center gap-2">
            <ng-select labelForId="paymentAccountSelectFull" class="flex-grow-1" [clearable]="false" formControlName="paymentAccount"
              [items]="accountState['Full'].list" bindLabel="accountName" bindValue="_id" placeholder="Select Account"
              [loading]="accountState['Full'].loading" (scrollToEnd)="onAccountScroll('Full')">
            </ng-select>
            @if (userDetails?.enrollmentType === "Company") {
            <button type="button" class="btn app-btn-outline btn-sm" (click)="
                    addNewPaymentAccount(
                      addServiceForm.get('paymentMode')?.value
                    )
                  " title="Add New Payment Account">
              <fa-icon [icon]="faPlus"></fa-icon>
            </button>
            }
          </div>
        </div>
        }
      </div>
      @if (showSplitPaymentOption) {
      <div class="row pt-3">
        <div class="col-md-6 mb-3">
          <div class="border rounded p-3" style="
                background-color: #f8f9fa;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
              ">
            <div class="row g-2">
              <div class="col-6">
                <label for="cashAmount">Cash Amount</label>
                <input formControlName="cashAmount" id="cashAmount" type="number"
                  class="form-control no-spinner default-form-group-border" placeholder="Cash amount"
                  (input)="splitAmountSum()" appBlockNumberSpecialchars/>
              </div>
              <div class="col-6">
                <label for="cashAccountSelect">Payment Account</label>
                <div class="d-flex align-items-center gap-2">
                  <ng-select labelForId="cashAccountSelect" class="flex-grow-1" [clearable]="false"
                    [readonly]="!addServiceForm.get('cashAmount')?.value" formControlName="cashAccount"
                    [items]="accountState['Cash'].list" bindLabel="accountName" bindValue="_id"
                    placeholder="Select Account" [loading]="accountState['Cash'].loading"
                    (scrollToEnd)="onAccountScroll('Cash')">
                  </ng-select>
                  @if (userDetails?.enrollmentType === "Company") {
                  <button type="button" class="btn app-btn-outline btn-sm" (click)="addNewPaymentAccount('Cash')"
                    title="Add New Cash Payment Account">
                    <fa-icon [icon]="faPlus"></fa-icon>
                  </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="border rounded p-3" style="
                background-color: #f8f9fa;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
              ">
            <div class="row g-2">
              <div class="col-6">
                <label for="bankTransferAmount">Bank Transfer Amount</label>
                <input formControlName="bankTransferAmount" id="bankTransferAmount" type="number" appBlockNumberSpecialchars
                  class="form-control no-spinner default-form-group-border" placeholder="Bank transfer amount"
                  (input)="splitAmountSum()" />
              </div>
              <div class="col-6">
                <label for="bankTransferAccountSelect">Payment Account</label>
                <div class="d-flex align-items-center gap-2">
                  <ng-select labelForId="bankTransferAccountSelect" class="flex-grow-1" [clearable]="false" [readonly]="
                        !addServiceForm.get('bankTransferAmount')?.value
                      " formControlName="bankTransferAccount" [items]="accountState['BankTransfer'].list"
                    bindLabel="accountName" bindValue="_id" placeholder="Select Account"
                    [loading]="accountState['BankTransfer'].loading" (scrollToEnd)="onAccountScroll('BankTransfer')">
                  </ng-select>
                  @if (userDetails?.enrollmentType === "Company") {
                  <button type="button" class="btn app-btn-outline btn-sm"
                    (click)="addNewPaymentAccount('BankTransfer')" title="Add New Bank Transfer Payment Account">
                    <fa-icon [icon]="faPlus"></fa-icon>
                  </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="border rounded p-3" style="
                background-color: #f8f9fa;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
              ">
            <div class="row g-2">
              <div class="col-6">
                <label for="upiAmountInput">UPI Amount</label>
                <input formControlName="upiAmount" id="upiAmountInput" #upiAmount type="number"
                  class="form-control no-spinner default-form-group-border" placeholder="UPI amount"
                  (input)="splitAmountSum()" appBlockNumberSpecialchars />
              </div>
              <div class="col-6">
                <label for="upiAccountSelect">Payment Account</label>
                <div class="d-flex align-items-center gap-2">
                  <ng-select labelForId="upiAccountSelect" class="flex-grow-1" [clearable]="false"
                    [readonly]="!addServiceForm.get('upiAmount')?.value" formControlName="upiAccount"
                    [items]="accountState['UPI'].list" bindLabel="accountName" bindValue="_id"
                    placeholder="Select Account" [loading]="accountState['UPI'].loading"
                    (scrollToEnd)="onAccountScroll('UPI')">
                  </ng-select>
                  @if (userDetails?.enrollmentType === "Company") {
                  <button type="button" class="btn app-btn-outline btn-sm" (click)="addNewPaymentAccount('UPI')"
                    title="Add New UPI Payment Account">
                    <fa-icon [icon]="faPlus"></fa-icon>
                  </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="border rounded p-3" style="
                background-color: #f8f9fa;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
              ">
            <div class="row g-2">
              <div class="col-6">
                <label for="bajajFinanceAmountInput">Bajaj Finance Amount</label>
                <input formControlName="bajajFinanceAmount" id="bajajFinanceAmountInput" type="number"
                  class="form-control no-spinner default-form-group-border" placeholder="Enter amount"
                  (input)="splitAmountSum()" appBlockNumberSpecialchars/>
              </div>
              <div class="col-6">
                <label for="bajajFinanceAccountSelect">Payment Account</label>
                <div class="d-flex align-items-center gap-2">
                  <ng-select labelForId="bajajFinanceAccountSelect" class="flex-grow-1" [clearable]="false" [readonly]="
                        !addServiceForm.get('bajajFinanceAmount')?.value
                      " formControlName="bajajFinanceAccount" [items]="accountState['BajajFinance'].list"
                    bindLabel="accountName" bindValue="_id" placeholder="Select Account"
                    [loading]="accountState['BajajFinance'].loading" (scrollToEnd)="onAccountScroll('BajajFinance')">
                  </ng-select>
                  @if (userDetails?.enrollmentType === "Company") {
                  <button type="button" class="btn app-btn-outline btn-sm"
                    (click)="addNewPaymentAccount('BajajFinance')" title="Add New Bajaj Finance Payment Account">
                    <fa-icon [icon]="faPlus"></fa-icon>
                  </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="border rounded p-3" style="
                background-color: #f8f9fa;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
              ">
            <div class="row g-2">
              <div class="col-12 col-sm-6">
                <label for="cardAmountInput">Card Amount</label>
                <input formControlName="cardAmount" id="cardAmountInput" #cardAmount type="number" appBlockNumberSpecialchars
                  class="form-control no-spinner default-form-group-border" placeholder="Card amount"
                  (input)="splitAmountSum()" />
              </div>
              <div class="col-12 col-sm-6">
                <label for="cardAccountSelect">Payment Account</label>
                <div class="d-flex align-items-center gap-1">
                  <ng-select labelForId="cardAccountSelect" class="flex-grow-1" [clearable]="false"
                    [readonly]="!addServiceForm.get('cardAmount')?.value" formControlName="cardAccount"
                    [items]="accountState['Card'].list" bindLabel="accountName" bindValue="_id"
                    placeholder="Select Account" [loading]="accountState['Card'].loading"
                    (scrollToEnd)="onAccountScroll('Card')">
                  </ng-select>
                  @if (userDetails?.enrollmentType === "Company") {
                  <button type="button" class="btn app-btn-outline btn-sm" (click)="addNewPaymentAccount('Card')"
                    title="Add New Card Payment Account">
                    <fa-icon [icon]="faPlus"></fa-icon>
                  </button>
                  }
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <label for="swpChargesCardInput">SWP Charges</label>
                <input formControlName="swpCharges" id="swpChargesCardInput" type="number"
                  [readonly]="!addServiceForm.get('cardAmount')?.value"
                  class="form-control no-spinner default-form-group-border" placeholder="Swipe charge %"
                  (input)="calculateTotalService()" />
              </div>
              <div class="col-12 col-sm-6 d-flex flex-column justify-content-center">
                <span class="text-muted small d-block">SWP Amount</span>
                <span class="text-dark fs-6">₹{{ swpCharges || 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
      <h3 class="pt-3">Customer Details:</h3>
      <div class="row pt-3 g-3">
        <div class="col-12 col-sm-6 col-md-3">
          <label for="phoneNumberInput">Phone Number<span class="text-danger">*</span></label>
          <input formControlName="phoneNumber" id="phoneNumberInput" class="form-control no-spinner default-form-group-border" type="number"
            (input)="onInput($event)" placeholder="Phone number" (keyup)="getUserIdsFirstWay($event)"
            list="dynmicUserIds" [(ngModel)]="this.selectedPhoneNumber"
            (change)="onOptionPhoneSelected(this.selectedPhoneNumber)" />
          <datalist id="dynmicUserIds">
            @for (item of phoneList; track item) {
            <option (click)="onOptionPhoneSelected(item)">
              {{ item.phoneNumber }}
            </option>
            }
          </datalist>
          @if (
          addServiceForm.get("phoneNumber")?.invalid &&
          addServiceForm.get("phoneNumber")?.touched
          ) {
          <div>
            @if (addServiceForm.get("phoneNumber")?.hasError("required")) {
            <small class="text-danger">Enter phone number</small>
            }
          </div>
          }
          @if (addServiceForm.get("phoneNumber")?.hasError("pattern")) {
          <div>
            <small class="text-danger">Enter a valid phone number</small>
          </div>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="customerName">Customer Name<span class="text-danger">*</span></label>
          <input formControlName="customerName" id="customerName" class="form-control default-form-group-border"
            placeholder="Customer name" required />
          @if (
          addServiceForm.get("customerName")?.invalid &&
          addServiceForm.get("customerName")?.touched
          ) {
          <div>
            <small class="text-danger">Enter customer name</small>
          </div>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="emailAddress">Email Address</label>
          <input formControlName="emailAddress" id="emailAddress" class="form-control default-form-group-border"
            placeholder="Email address" />
          @if (
          addServiceForm.get("emailAddress")?.hasError("pattern") &&
          !addServiceForm.get("emailAddress")?.hasError("required")
          ) {
          <div>
            <small class="text-danger">Enter a valid email address</small>
          </div>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="leadSelect">Lead</label>
          <ng-select labelForId="leadSelect" [items]="leadList" bindLabel="label" bindValue="value" formControlName="lead" [clearable]="false"
            placeholder="Select Lead From" (change)="checkLeadType($event.value)" class="custom-ng-select">
          </ng-select>
        </div>
        @if (showReferenceName) {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="referenceInput">Reference Number</label>
          <input formControlName="reference" id="referenceInput" #leadRefrenceName type="number" [appMaxLength]="10"
            class="form-control default-form-group-border" placeholder="Reference Mobile"
            (input)="onInputNumber($event)" />
          @if (addServiceForm.get("reference")?.hasError("pattern")) {
          <div>
            <small class="text-danger">Enter a valid Mobile Number</small>
          </div>
          }
        </div>
        }
        <div class="col-12 col-sm-6 col-md-3">
          <label for="averageRunPerDay">Average run per day(in km)</label>
          <input formControlName="averageRunPerDay" id="averageRunPerDay" type="number"
            class="form-control default-form-group-border" placeholder="Average run per day" />
        </div>
        <div class="col-12 col-sm-6 col-md-3" formGroupName="address">
          <label for="locality">Locality</label>
          <input formControlName="locality" id="locality" type="text" class="form-control default-form-group-border"
            placeholder="Locality" />
        </div>
      </div>
      @if (errorMessage) {
      <div class="text-center text-danger pt-2">
        {{ errorMessage }}
      </div>
      }
      <div class="row pt-3 mb-5">
        <div class="col-12 text-end">
          <button type="button" class="btn btn-outline-dark m-2" [routerLink]="'/order-list'" [disabled]="isLoading">
            Cancel
          </button>
          <button
            [disabled]="addServiceForm.invalid || !checkSplitCount || !hasAtLeastOneServiceSelected() || isLoading"
            type="submit" class="btn app-btn-primary">
            Submit
            @if (isLoading) {
             <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
            }
          </button>
        </div>
      </div>
    </form>

    <ng-template #accountFormModal let-offcanvas>
      <app-new-payment-account [showBranch]="true" [branches]="companyData" [preSelectedBranch]="preSelectedBranch"
        [preSelectedMode]="preSelectedMode" (accountSave)="onAccountSave($event)"
        (accountCancel)="offcanvas.dismiss()">
      </app-new-payment-account>
    </ng-template>
  </div>
</section>